"use client";

import { Toaster } from "sonner";

/**
 * Toasts ("Speichermeldungen"). We deliberately do NOT use sonner's `richColors`
 * — it produced low-contrast tinted-text-on-tinted-background toasts in our
 * OKLCH theme. Instead the per-type colours are defined in globals.css as a
 * SATURATED fill + WHITE text (WCAG-AA, theme-independent — Lesson 2026-07-04).
 */
export function ToasterProvider() {
  return <Toaster position="top-right" toastOptions={{ className: "lts-toast" }} />;
}
